
import Vue, { defineComponent } from "vue";
export default defineComponent({
  name: "newsSvg",
  components: {},
  props: {
    color: {
      type: String,
      default: "red",
    },
  },
});
